import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
// import { richTextValidation } from "@validations/utils";
import { TRANSFER_STATUS } from "@constants/status.hrm";

export const TRANSFER = FORM_FIELDS.TRANSFER.TRANSFER_DETAILS;

const { INITIATED, UPLOADED_NOC, SENT_FOR_DOCUMENTS_UPLOAD } = TRANSFER_STATUS;

export const transferDetailsValidation = yup.object().shape({
  [TRANSFER.JOINING_DATE]: yup.string().required("Date is required").nullable(),
  // [TRANSFER.LETTER]: richTextValidation(),
  [TRANSFER.RELEASE_DATE]: yup.string().required("Date is required"),
  [TRANSFER.DESIGNATION]: yup
    .number()
    .typeError("Designation is required")
    .required("Designation is required"),
  [TRANSFER.GRADE]: yup
    .number()
    .typeError("Grade is required")
    .required("Grade is required"),
  [TRANSFER.POSITION]: yup
    .number()
    .typeError("Position is required")
    .required("Position is required"),
  // [TRANSFER.JOINING_DATE]: yup
  //   .string()
  //   .required("Joining Date Date is required"),

  [TRANSFER.BASIC_SALARY]: yup
    .number()
    .nullable()
    // .min(0, "Basic salary can't be negative")
    // .required("Basic salary must be number. At least give 0 number")
    .typeError("Basic salary must be number."),

  [TRANSFER.JOINING_LETTER_DOCS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable()
    .when("status", {
      is: UPLOADED_NOC,
      then: (schema) =>
        schema
          .min(1, "Joining Letter is required")
          .required("Joining Letter is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  // .min(1, "Joining letter is required")
  // .typeError("Joining letter is required"),
  // .required("Joining letter is required"),
  [TRANSFER.NOC_DOCS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable()
    .when("status", {
      is: SENT_FOR_DOCUMENTS_UPLOAD,
      then: (schema) =>
        schema.min(1, "NOC is required").required("NOC is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  // .min(1, "NOC is required")
  // .required("NOC is required"),
  [TRANSFER.SUPPORTING_DOCS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
  [TRANSFER.ASSET_DOCS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable(),
  [TRANSFER.TRANSFER_DOCS]: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable()
    .when("status", {
      is: INITIATED,
      then: (schema) =>
        schema
          .min(1, "Transfer Docs is required")
          .required("Transfer Docs is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  [TRANSFER.COMMENT]: yup.string(),
});

export type TransferDetailsFormDataType = yup.InferType<
  typeof transferDetailsValidation
>;
